function hidePackofColorSwatchonSingleProduct() {
  if (!document.querySelector(".variant-input-wrap")) {
    const allColorSwatchButtons = document.querySelectorAll(".tab-swatch");

    allColorSwatchButtons.forEach((btn) => {
      const allColorSwatchProductHandles = btn.getAttribute("data-phandle");

      if (
        allColorSwatchProductHandles &&
        allColorSwatchProductHandles.includes("pack-of")
      ) {
        console.warn(allColorSwatchProductHandles);
        btn.style.display = "none";
        btn.closest(".type_swatch").classList.add("empty-span");
        
      }
    });

    const activeButton = document.querySelector(".tab-swatch.active");

    if (activeButton) {
      // Scroll the active button into view smoothly, ensuring no extra space on the right
      activeButton.scrollIntoView({
        behavior: "smooth",
        block: "nearest",  // Ensures the button aligns without extra space
        inline: "center"   // Scrolls the button to the center of the container
      });
      
      // After scrolling, ensure no white space appears on the right side
      const container = activeButton.closest('.tab-swatch-container'); // Adjust to your actual container class
      if (container) {
        container.style.overflow = 'hidden';  // Prevents extra overflow after scroll
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  
  hidePackofColorSwatchonSingleProduct()

  setTimeout(() => {
      const productTitleElement = document.querySelector(".m-product-title");
       if (productTitleElement) {
              const productTitle = productTitleElement.textContent.trim();
              if (productTitle.includes("PURESOFT")) {
               
                const reviewsTab = document.getElementById("custom-reviews-tab");
                console.warn(reviewsTab)
                if (reviewsTab) {
                    reviewsTab.style.display = "none";  
                } 

                const deskHideElement = document.querySelector(".m-price__sale .deskhide");
                if (deskHideElement) {
                    deskHideElement.style.display = "none"; 
                }

                const mobDissElement = document.querySelector(".mobdiss");
                if (mobDissElement) {
                    mobDissElement.style.display = "none";
                }
            }
        }
    }, 1500);  
});



// Out-of-stock design/print swatches get a faded + crossed look (still clickable, so the
// shopper can view the print and use Notify Me). Per the selected size when one is chosen,
// otherwise mark designs that are sold out in every size. The `.disabled` class drives the
// CSS (fade + diagonal cross; the active/selected swatch keeps the cross but isn't faded).
function handleTabSwatches() {
  const sizeVal = getSelectedDesignSizeValue();
  if (sizeVal) applyDesignSwatchInventoryForSize(sizeVal);
  else markFullySoldOutSwatches();
}

function getSelectedDesignSizeValue() {
  const r = document.querySelector(
    '.m-main-product variant-button[data-option-name="Size"] input[type="radio"]:checked'
  );
  if (r && r.value) return r.value;
  return (typeof lastSelectedSize !== "undefined" && lastSelectedSize && lastSelectedSize.selectedValue) || "";
}

function hasUserSelectedSize() {
  const checkedSize = document.querySelector(
    '.m-main-product variant-button[data-option-name="Size"] input[type="radio"]:checked'
  );
  return !!checkedSize;
}

function clearDesignSwatchDisabledState() {
  document.querySelectorAll(".type_swatch").forEach((item) => {
    if (item.classList.contains("pack-meta-swatch")) return;
    item.classList.remove("disabled");
  });
}

// A design is sold out for a size when its baked-in "<SIZE>-<inventory>" class token is 0
// or missing (e.g. class "... S-6 M-0 L-15 ..." → M is sold out for that design).
function applyDesignSwatchInventoryForSize(sizeValue) {
  if (!sizeValue) {
    markFullySoldOutSwatches();
    return;
  }
  const escaped = sizeValue.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const re = new RegExp("\\b" + escaped + "-(\\d+)\\b");
  document.querySelectorAll(".type_swatch").forEach(function (item) {
    if (item.classList.contains("pack-meta-swatch")) return;
    item.classList.remove("disabled");
    const m = item.className.match(re);
    if (!m || parseInt(m[1], 10) < 1) item.classList.add("disabled");
  });
}

// A design is fully sold out when every "<SIZE>-<inventory>" token is 0 (no size available).
function markFullySoldOutSwatches() {
  document.querySelectorAll(".type_swatch").forEach(function (item) {
    if (item.classList.contains("pack-meta-swatch")) return;
    item.classList.remove("disabled");
    const tokens = item.className.match(/\b[A-Za-z0-9]+-(\d+)\b/g) || [];
    const soldOut =
      tokens.length > 0 &&
      tokens.every(function (t) {
        return parseInt(t.split("-").pop(), 10) < 1;
      });
    if (soldOut) item.classList.add("disabled");
  });
}

let selectedSize = "";

let lastSelectedSize = {
  optionName: "Size",
  selectedValue: "",
};

window.__acLastSelectedSize = lastSelectedSize;

// Prevent double-triggering swatch/pack swaps (e.g. rapid double click)
// while the fetch + DOM swap is still in-flight.
let __acSwatchSeq = 0;
let __acSwatchPendingHandle = "";

const __acMainSectionCache = Object.create(null);
const __acMainSectionInflight = Object.create(null);
const __acMainSectionPreloadAttempted = Object.create(null);

function getShopifyRoutesRoot() {
  try {
    if (window.Shopify?.routes?.root) {
      const r = String(window.Shopify.routes.root);
      return r.endsWith("/") ? r : r + "/";
    }
  } catch (e) {
    /* ignore */
  }
  return "/";
}

function productUrlFromHandle(handle) {
  const h = (handle || "").trim();
  if (!h) return "";
  let url = `${getShopifyRoutesRoot()}products/${encodeURIComponent(h)}`;
  try {
    const view = new URLSearchParams(window.location.search).get("view");
    if (view) {
      url += `?view=${encodeURIComponent(view)}`;
    }
  } catch (e) {
    /* ignore */
  }
  return url;
}

function cacheKeyForProductUrl(url) {
  if (!url) return "";
  return url.split("#")[0];
}

function parseSectionInnerHtml(html, domSectionId) {
  const trimmed = (html || "").trim();
  if (!trimmed) return "";
  const parsed = new DOMParser().parseFromString(trimmed, "text/html");
  const byId = parsed.getElementById(domSectionId);
  if (byId) return byId.innerHTML;

  const shopifySection = parsed.querySelector(".shopify-section");
  if (shopifySection) return shopifySection.innerHTML;

  // Section API returns a fragment (stylesheet links, <style>, then markup) without
  // the shopify-section wrapper — use the full body, not firstElementChild only.
  if (parsed.body?.innerHTML) return parsed.body.innerHTML;

  return trimmed;
}

function activateInlineScripts(root) {
  if (!root) return;
  root.querySelectorAll("script:not([src])").forEach((oldScript) => {
    const text = oldScript.textContent || "";
    if (!text.includes("_themeProducts")) return;
    const newScript = document.createElement("script");
    newScript.textContent = text;
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
}

/** Section Rendering API only — never downloads the full PDP HTML. */
async function fetchSectionHtmlByTemplateId(productHandle, templateSectionId) {
  if (!productHandle || !templateSectionId) {
    throw new Error("missing product handle or section id");
  }

  const baseUrl = productUrlFromHandle(productHandle);
  const sep = baseUrl.includes("?") ? "&" : "?";

  const sectionsUrl = `${baseUrl}${sep}sections=${encodeURIComponent(templateSectionId)}`;
  const sectionsRes = await fetch(sectionsUrl, {
    credentials: "same-origin",
    headers: { Accept: "application/json" },
    priority: "high",
  });
  if (sectionsRes.ok) {
    const json = await sectionsRes.json();
    const html = json[templateSectionId];
    if (typeof html === "string" && html.trim()) return html;
  }

  const sectionIdUrl = `${baseUrl}${sep}section_id=${encodeURIComponent(templateSectionId)}`;
  const sectionIdRes = await fetch(sectionIdUrl, {
    credentials: "same-origin",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    priority: "high",
  });
  if (sectionIdRes.ok) {
    const html = (await sectionIdRes.text()).trim();
    if (html) return html;
  }

  throw new Error(
    `Section Rendering API failed for ${templateSectionId} (HTTP ${sectionsRes.status})`
  );
}

async function fetchMainProductSectionFromFullDocument(
  productHandle,
  domSectionId
) {
  const baseUrl = productUrlFromHandle(productHandle);
  const fullRes = await fetch(baseUrl, {
    credentials: "same-origin",
    priority: "high",
  });
  if (!fullRes.ok) {
    throw new Error(`product HTTP ${fullRes.status}`);
  }
  const markup = await fullRes.text();
  const doc = new DOMParser().parseFromString(markup, "text/html");
  const section =
    doc.getElementById(domSectionId) ||
    doc.querySelector(".pp-swatch")?.closest(".shopify-section") ||
    doc.querySelector(".m-main-product")?.closest(".shopify-section");
  if (!section) {
    throw new Error("main section not found in full document");
  }
  return section.innerHTML;
}

async function fetchMainProductSectionInnerHtml(
  productHandle,
  domSectionId,
  templateSectionId
) {
  const baseUrl = productUrlFromHandle(productHandle);
  const cacheKey = `${cacheKeyForProductUrl(baseUrl)}::${templateSectionId}`;

  if (__acMainSectionCache[cacheKey]) {
    return __acMainSectionCache[cacheKey];
  }

  if (__acMainSectionInflight[cacheKey]) {
    return __acMainSectionInflight[cacheKey];
  }

  const fetchPromise = (async () => {
    try {
      const html = await fetchSectionHtmlByTemplateId(
        productHandle,
        templateSectionId
      );
      const inner = parseSectionInnerHtml(html, domSectionId);
      if (inner) return inner;
    } catch (e) {
      /* fall through to full document */
    }
    return fetchMainProductSectionFromFullDocument(productHandle, domSectionId);
  })();

  __acMainSectionInflight[cacheKey] = fetchPromise;
  try {
    const result = await fetchPromise;
    if (!result) {
      throw new Error(`empty main section html for ${templateSectionId}`);
    }
    __acMainSectionCache[cacheKey] = result;
    return result;
  } finally {
    delete __acMainSectionInflight[cacheKey];
  }
}

function applySectionHtmlToWrapper(wrapper, html, domSectionId) {
  if (!wrapper) return;
  const inner = parseSectionInnerHtml(html, domSectionId);
  if (!inner) {
    wrapper.innerHTML = "";
    wrapper.hidden = true;
    return;
  }
  wrapper.hidden = false;
  wrapper.innerHTML = inner;
  wrapper.querySelectorAll('img[loading="lazy"]').forEach((img) => {
    img.removeAttribute("loading");
  });
  activateInlineScripts(wrapper);
}

// Download the product images found in the section HTML into the browser cache now,
// so when the carousel is swapped in on click the images are already there.
function prefetchSectionImages(json) {
  try {
    let count = 0;
    Object.keys(json || {}).forEach((k) => {
      if (typeof json[k] !== "string" || count >= 12) return;
      const doc = new DOMParser().parseFromString(json[k], "text/html");
      doc.querySelectorAll("img").forEach((img) => {
        if (count >= 12) return;
        const src = img.getAttribute("src");
        const srcset = img.getAttribute("srcset");
        if (!src && !srcset) return;
        const pre = new Image();
        const sizes = img.getAttribute("sizes");
        if (sizes) pre.sizes = sizes;
        if (srcset) pre.srcset = srcset;
        if (src) pre.src = src;
        count++;
      });
    });
  } catch (e) {
    /* ignore */
  }
}

// Batch Section-API response (carousel, banner, Lavi Advance...) per product, cached so
// a swatch that was warmed up in advance swaps its images instantly on click.
const __acAuxSectionsCache = Object.create(null);

function fetchAuxSectionsJson(productHandle, plan) {
  if (!productHandle || !plan || !plan.length) return Promise.resolve(null);
  const baseUrl = productUrlFromHandle(productHandle);
  const sep = baseUrl.includes("?") ? "&" : "?";
  const sectionsParam = plan
    .map((entry) => encodeURIComponent(entry.templateSectionId))
    .join(",");
  const key = `${cacheKeyForProductUrl(baseUrl)}::${sectionsParam}`;
  if (__acAuxSectionsCache[key]) return __acAuxSectionsCache[key];

  const promise = fetch(`${baseUrl}${sep}sections=${sectionsParam}`, {
    credentials: "same-origin",
    headers: { Accept: "application/json" },
    priority: "high",
  })
    .then((response) => (response.ok ? response.json() : null))
    .catch((error) => {
      console.warn("Batch section refresh failed, falling back to sequential", error);
      return null;
    })
    .then((json) => {
      if (!json) delete __acAuxSectionsCache[key]; // don't cache failures
      else prefetchSectionImages(json);
      return json;
    });
  __acAuxSectionsCache[key] = promise;
  return promise;
}

async function refreshProductAjaxSectionsSequential(productHandle) {
  if (!productHandle) return;

  const plan = collectOrderedProductAjaxSections();
  if (!plan.length) return;

  const sectionsJson = await fetchAuxSectionsJson(productHandle, plan);

  for (const entry of plan) {
    const wrapper = document.getElementById(entry.domSectionId);
    if (!wrapper) continue;

    try {
      let html =
        sectionsJson && typeof sectionsJson[entry.templateSectionId] === "string"
          ? sectionsJson[entry.templateSectionId]
          : null;

      if (!html || !html.trim()) {
        html = await fetchSectionHtmlByTemplateId(
          productHandle,
          entry.templateSectionId
        );
      }

      applySectionHtmlToWrapper(wrapper, html, entry.domSectionId);
    } catch (error) {
      console.error(
        `Error refreshing ${entry.kind} section ${entry.templateSectionId}:`,
        error
      );
      wrapper.innerHTML = "";
      wrapper.hidden = true;
    }
  }
}

/** Standalone template breadcrumb section (outside .m-main-product). */
function findStandaloneBreadcrumbWrapper() {
  const mainProduct = document.querySelector(".m-main-product");
  const navs = document.querySelectorAll("nav.m-breadcrumb");
  for (const nav of navs) {
    if (mainProduct && mainProduct.contains(nav)) continue;
    const wrapper = nav.closest('[id^="shopify-section-"]');
    if (wrapper) return wrapper;
  }
  return null;
}

/**
 * Product-adjacent sections to refresh after a swatch swap, in document order
 * (breadcrumb first, then carousel before banner on SS26 PDPs). Carousel kind
 * sorts before banner when both share the same position.
 */
function collectOrderedProductAjaxSections() {
  const candidates = [];

  function addCandidate(el, kind) {
    const templateSectionId = resolveProductMetafieldSectionId(el);
    if (!templateSectionId) return;
    candidates.push({
      templateSectionId,
      domSectionId: `shopify-section-${templateSectionId}`,
      kind,
      el,
    });
  }

  const breadcrumbWrapper = findStandaloneBreadcrumbWrapper();
  if (breadcrumbWrapper) {
    addCandidate(breadcrumbWrapper, "breadcrumb");
  }

  document
    .querySelectorAll(
      '.m-pdp-image-carousel[data-section-type="pdp-image-carousel"], [data-section-type="pdp-image-carousel"]'
    )
    .forEach((el) => addCandidate(el, "carousel"));

  document
    .querySelectorAll('.shopify-section-pdp-image-carousel[id^="shopify-section-"]')
    .forEach((wrapper) => {
      addCandidate(wrapper, "carousel");
    });

  document.querySelectorAll('[data-section-type="image-banner"]').forEach((el) => {
    addCandidate(el, "banner");
  });

  // Lavi Advance section (Style Description, Fabric, Wash Care, Why-different banner + squares,
  // Fit, How to wear, What Bra) — per-product metafield content, must refresh on colour swap.
  document.querySelectorAll(".section-lavi-advance").forEach((el) => {
    addCandidate(el, "lavi");
  });

  const seen = new Set();
  const kindRank = { breadcrumb: -1, carousel: 0, banner: 1, lavi: 2 };
  return candidates
    .filter((entry) => {
      if (seen.has(entry.templateSectionId)) return false;
      seen.add(entry.templateSectionId);
      return true;
    })
    .sort((a, b) => {
      const pos = a.el.compareDocumentPosition(b.el);
      if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
      if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;
      return kindRank[a.kind] - kindRank[b.kind];
    })
    .map(({ templateSectionId, domSectionId, kind }) => ({
      templateSectionId,
      domSectionId,
      kind,
    }));
}

function preloadSwatchProductSection(
  productHandle,
  domSectionId,
  templateSectionId
) {
  if (!productHandle || !templateSectionId) return;
  const cacheKey = `${cacheKeyForProductUrl(productUrlFromHandle(productHandle))}::${templateSectionId}`;
  if (__acMainSectionCache[cacheKey] || __acMainSectionPreloadAttempted[cacheKey]) {
    return;
  }
  __acMainSectionPreloadAttempted[cacheKey] = true;
  try {
    fetchAuxSectionsJson(productHandle, collectOrderedProductAjaxSections());
  } catch (e) {
    /* ignore */
  }
  return fetchMainProductSectionInnerHtml(
    productHandle,
    domSectionId,
    templateSectionId
  ).catch(() => {});
}

function deferSwatchSecondaryWork(fn) {
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(fn, { timeout: 2000 });
  } else {
    setTimeout(fn, 0);
  }
}

function eagerLoadSwatchImages(root) {
  if (!root) return;
  root.querySelectorAll(".tab-swatch img").forEach((img) => {
    if (img.hasAttribute("loading")) {
      img.removeAttribute("loading");
    }
    if (img.hasAttribute("data-src")) {
      img.src = img.getAttribute("data-src");
      img.removeAttribute("data-src");
    }
  });
}

function resolveProductMetafieldSectionId(el) {
  if (!el) return "";
  const fromData = (el.getAttribute("data-section-id") || "").trim();
  if (fromData) return fromData;
  const wrapper = el.closest('[id^="shopify-section-"]');
  if (wrapper && wrapper.id) {
    return wrapper.id.replace(/^shopify-section-/, "");
  }
  if (el.id && el.id.startsWith("shopify-section-")) {
    return el.id.replace(/^shopify-section-/, "");
  }
  return "";
}

function getProductHandleFromPath() {
  const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  return match ? decodeURIComponent(match[1]) : "";
}

async function runPackSwappedProductRefresh() {
  const handle = getProductHandleFromPath();
  if (!handle) return;

  await reselectSizeButton(handle);

  // Phase 1: product info (main section already swapped by lavi-cross-variant)
  styleSelect();
  updateSwatchGroups();
  handleTabSwatches();
  if (typeof window.ensureSnfSizeCalculator === "function") {
    await window.ensureSnfSizeCalculator(document);
  }
  document.dispatchEvent(new CustomEvent("ProductVariantDataUpdated"));

  // Phase 2: carousel, then image banner (sequential Section API)
  await refreshProductAjaxSectionsSequential(handle);
}

document.addEventListener("pack:swapped", function () {
  runPackSwappedProductRefresh();
});

// One delegated listener — never stack. (recordSizeSelection used to add N listeners per section click.)
(function bindProductSizeSelectionOnce() {
  if (window.__acProductSizeRecordBound) return;
  window.__acProductSizeRecordBound = true;
  document.addEventListener(
    "click",
    function (e) {
      const opt = e.target.closest(
        '.m-product-option--node[data-option-type="button"]'
      );
      if (!opt) return;
      const main = document.querySelector(".m-main-product");
      if (!main || !main.contains(opt)) return;
      const sizeValue = opt.getAttribute("data-value") || "";
      lastSelectedSize.selectedValue = sizeValue;
      if (typeof window.setAcPdpSizeMemory === "function") {
        window.setAcPdpSizeMemory(sizeValue);
      }
    },
    false
  );
})();

function styleSelect() {
  const tabs = document.querySelectorAll(".tab-button");
  const swatches = document.querySelectorAll(".type_swatch");
  const tabComponent = document.querySelector(".tab-component");
  const productForm = document.querySelector(".product-form");
  const mpId = productForm?.dataset?.productId;
  const swatchButtons = document.querySelectorAll(".tab-swatch");

  tabs.forEach((tab) => {
    if (tab.dataset.acStyleSelectTabBound === "1") return;
    tab.dataset.acStyleSelectTabBound = "1";
    tab.addEventListener("click", function () {
      // Remove 'active' class from all tabs
      tabs.forEach((t) => t.classList.remove("active"));

      // Add 'active' class to the clicked tab
      tab.classList.add("active");
      // Save current page step in local storage

      // Get the filter type from the clicked tab and convert it to lowercase
      const filterType = tab.getAttribute("data-name").toLowerCase();

      localStorage.setItem("slected-design-tab", filterType);
      // console.log('slected-design-tab', filterType);

      // If the "All" tab is clicked, show all swatches
      if (filterType === "all") {
        swatches.forEach((swatch) => {
          // Pack-meta swatches are controlled by pack-size filtering — don't override
          if (swatch.classList.contains("pack-meta-swatch")) return;
          swatch.style.display = "inline-block";
        });
      } else {
        // Otherwise, show only the swatches that have the matching class
        swatches.forEach((swatch) => {
          // Pack-meta swatches are controlled by pack-size filtering — don't override
          if (swatch.classList.contains("pack-meta-swatch")) {
            return;
          }
          if (swatch.classList.contains(filterType)) {
            swatch.style.display = "inline-block";
          } else {
            swatch.style.display = "none";
          }
        });
      }
    });
  });

  // Activate the swatch button with matching pid on page load
  swatchButtons.forEach((button) => {
    button.classList.toggle("active", button.dataset.pid == mpId);
    button.onclick = function(){
      setTimeout(function(){
        localStorage.removeItem("selectedSize");
        localStorage.removeItem("selectedVariant");
        var elementToSkip = document.getElementById("addsnfwidgethere");
        if (elementToSkip) {
            elementToSkip.remove(); // Remove it from the response
        }
      }, 1000);
    }    
  });  
  reselectTab();
}
styleSelect();
/*

         // Select and log size options
         const sizeOptions = document.querySelectorAll('variant-button[data-picker-field="radio"][data-option-name="Size"]');
         console.log("Size options found:", sizeOptions.length);
         if (sizeOptions.length === 0) {
            console.error('No size option elements found.');
            return;
         }

         // Size selection event
         sizeOptions.forEach(function (sizeOption) {
            sizeOption.addEventListener('click', function () {
              selectedSize = sizeOption.getAttribute('data-selected-value');
               console.log("Size selected:", selectedSize);

               document.querySelectorAll('.type_swatch').forEach(function (item) {
                  // Assume the item should not be displayed by default
                  let displayItem = false;

                  // Split the class string by spaces to get individual classes
                  const classes = item.className.split(/\s+/);

                  classes.forEach(function (className) {
                     console.log("classesName", className);
                     // Directly check if the class contains the selected size
                     if (className.includes(`${selectedSize}/`)) {
                        // Extract the inventory number after the last hyphen
                        const inventory = parseInt(className.split('-').pop(), 10);
                        console.log("classes", 'yes');
                        console.log("inventory", inventory);
                        // If inventory is 5 or more, mark the item to be displayed
                        if (!isNaN(inventory) && inventory >= 5) {
                           displayItem = true;
                        }
                     }
                  });

                  // Set the display property based on the inventory check
                  item.style.display = displayItem ? '' : 'none';
               });
            });
         });


*/

// function reselectTab() {
//   // Retrieve the selected design tab name from localStorage and convert it to lower case
//   const selectedTabName = localStorage.getItem('slected-design-tab').toLowerCase(); // Correcting the typo 'slected' to 'selected'

//   // Select all tab buttons
//   const tabButtons = document.querySelectorAll('.pp-swatch .tab-button');
// console.log("reselectTab selected tab");
//   // Loop through the tab buttons to add or remove the active class
//   tabButtons.forEach(button => {
//     console.log("before selected tab", button.getAttribute('data-name').toLowerCase());
//     if (button.getAttribute('data-name').toLowerCase() === selectedTabName) {

//       console.log("selected tab", button.getAttribute('data-name').toLowerCase());
//       // Add active class to the matching tab
//       button.classList.add('active');
//     } else {
//       // Remove active class from non-matching tabs
//       button.classList.remove('active');
//     }
//   });
// }
// reselectTab();

function reselectTab() {
  // Retrieve the selected design tab name from localStorage. Correcting typo 'slected' to 'selected'.
  const selectedTabName = localStorage.getItem("slected-design-tab"); // Use the corrected key name

  const tabButtons = Array.from(
    document.querySelectorAll(".pp-swatch .tab-button")
  );
  if (!tabButtons.length) return;

  const desired = (selectedTabName || "all").toLowerCase();

  let desiredButton = null;
  tabButtons.forEach((button) => {
    const name = (button.getAttribute("data-name") || "").toLowerCase();
    const isDesired = name === desired;
    button.classList.toggle("active", isDesired);
    if (isDesired) desiredButton = button;
  });

  // Critical: setting `.active` alone does not hide/show swatches.
  // Trigger the tab click handler so swatches are filtered correctly
  // (especially after the product section is swapped via fetch()).
  if (!desiredButton) {
    desiredButton =
      tabButtons.find(
        (b) => (b.getAttribute("data-name") || "").toLowerCase() === "all"
      ) || tabButtons[0];
    desiredButton.classList.add("active");
  }
  desiredButton.click();
}

reselectTab();

function addStock() {
  var variantIdInput = document.querySelector(
    '.m-product-form input[name="id"]'
  );
  if (!variantIdInput) {
    console.error("Variant ID input element not found.");
    return;
  }
  if (variantIdInput.dataset.acStockBound === "1") {
    updateStockDisplay(variantIdInput.value);
    return;
  }
  variantIdInput.dataset.acStockBound = "1";
  var variantId = 10;
  const variantStockString = document
    .querySelector(".main-product")
    .getAttribute("data-variant-stock");
  const decodedString = decodeURIComponent(variantStockString);
  variantStock = JSON.parse(decodedString);
  // console.log(variantStock);
  // Function to call when the variant ID changes

  function onVariantIdChange(event) {
    variantId = event.target.value; // Get the new variant ID
    // console.log('New variant ID:', variantId);
    updateStockDisplay(variantId);

    // Now you can call any functions you need to process this new variant ID
    // For example:
    // updateStockDisplay(variantId);
  }
  // Add the event listener to the variant ID input
  if (variantIdInput) {
    variantIdInput.addEventListener("change", onVariantIdChange);
    onVariantIdChange({ target: variantIdInput });
  } else {
    console.error("Variant ID input element not found.");
  }
}
addStock();

function updateStockDisplay(variantId) {
  // Check if the variant ID is in the stock data
  const stockCount = variantStock[variantId];

  // console.log(`Stock for variant ${variantId}:`, stockCount);

  // Step 3: Update the display based on stock
  const inventoryWrapper = document.querySelector(".inventoryWrapper-main");
  const selectedValueColor = document.querySelector(".inventoryWrapper");

  if (stockCount && stockCount < 5) {
    // Show the inventory warning if stock is less than 5
    if (inventoryWrapper) {
      inventoryWrapper.classList.remove("hidden");
    }
    if (selectedValueColor) {
      selectedValueColor.textContent = stockCount;
    }
  } else {
    // Optionally hide or alter the inventory warning if stock is sufficient
    if (inventoryWrapper) {
      inventoryWrapper.classList.add("hidden");
    }
  }

  // Update any Low Stock Progress Bar blocks on the page
  document.querySelectorAll("[data-stock-progress-bar]").forEach(function (bar) {
    const startingInventory = parseFloat(bar.dataset.startingInventory) || 1;
    let showBelow = parseFloat(bar.dataset.showBelow);
    if (!showBelow) showBelow = startingInventory;
    const template =
      bar.dataset.messageTemplate || "Hurry, only {count} left in stock!";
    const msgEl = bar.querySelector(".stock-progress-bar__message");
    const fillEl = bar.querySelector(".stock-progress-bar__fill");

    if (stockCount && stockCount > 0 && stockCount <= showBelow) {
      let percent = (stockCount / startingInventory) * 100;
      if (percent > 100) percent = 100;
      if (fillEl) fillEl.style.width = percent + "%";
      if (msgEl) msgEl.textContent = template.replace("{count}", stockCount);
      bar.style.display = "";
    } else {
      bar.style.display = "none";
    }
  });
}

// Invoke the function to check and display stock information

document.addEventListener("DOMContentLoaded", function () {
  lastSelectedSize.selectedValue = "";
  const checkedSize = document.querySelector(
    '.m-main-product variant-button[data-option-name="Size"] input[type="radio"]:checked'
  );
  if (checkedSize) {
    lastSelectedSize.selectedValue = checkedSize.value;
    reselectSizeButton();
  } else {
    markFullySoldOutSwatches();
  }
  function toggleAddToCartButtons(active) {
    // Select all elements with the class 'm-add-to-cart' and 'm-sticky-addtocart'
    const addToCartButtons = document.querySelectorAll(
      ".m-add-to-cart, .m-sticky-addtocart"
    );

    // Iterate over each button and toggle the 'disabled' class based on the active parameter
    addToCartButtons.forEach((button) => {
      if (active) {
        button.classList.remove("disabled");
      } else {
        button.classList.add("disabled");
      }
    });
  }

  // Query the DOM for the first element with the class 'm-main-product'
  var mMainProductElement = document.querySelector(".m-main-product");
  const nearestSection = mMainProductElement.closest(".shopify-section");
  const sectionId = nearestSection.id;

  // To fix quinn video saw onclick of swatch function start
  
  const scriptUrls = [
    "https://cdn.shopify.com/extensions/3bb43167-4454-4c20-973f-952ee381cbbe/quinn-shoppable-videos-457/assets/quinn-live.bundle.js",
    "https://cdn.shopify.com/extensions/3bb43167-4454-4c20-973f-952ee381cbbe/quinn-shoppable-videos-457/assets/quinn-vendor.bundle.js",
    "https://cdn.shopify.com/extensions/3bb43167-4454-4c20-973f-952ee381cbbe/quinn-shoppable-videos-457/assets/OverlayCarouselBody-svelte.js",
    "https://cdn.shopify.com/extensions/3bb43167-4454-4c20-973f-952ee381cbbe/quinn-shoppable-videos-457/assets/quinn-floating.bundle.js",
    "https://cdn.shopify.com/extensions/3bb43167-4454-4c20-973f-952ee381cbbe/quinn-shoppable-videos-457/assets/quinn-story.bundle.js",
    "https://cdn.shopify.com/extensions/3bb43167-4454-4c20-973f-952ee381cbbe/quinn-shoppable-videos-457/assets/quinn-imaxvideo.bundle.js",
    "https://cdn.shopify.com/extensions/3bb43167-4454-4c20-973f-952ee381cbbe/quinn-shoppable-videos-457/assets/quinn-cards.bundle.js",
    "https://cdn.shopify.com/extensions/3bb43167-4454-4c20-973f-952ee381cbbe/quinn-shoppable-videos-457/assets/quinn-grid.bundle.js",
    "https://cdn.shopify.com/extensions/3bb43167-4454-4c20-973f-952ee381cbbe/quinn-shoppable-videos-457/assets/CardAndStoryCarouselBody-svelte.js",
    "https://cdn.shopify.com/extensions/3bb43167-4454-4c20-973f-952ee381cbbe/quinn-shoppable-videos-457/assets/WidgetMedia-svelte.js",
    "https://cdn.shopify.com/extensions/3bb43167-4454-4c20-973f-952ee381cbbe/quinn-shoppable-videos-457/assets/WidgetText-svelte.js",
    "https://cdn.shopify.com/extensions/3bb43167-4454-4c20-973f-952ee381cbbe/quinn-shoppable-videos-457/assets/WidgetPrice-svelte.js",
    "https://cdn.shopify.com/extensions/3bb43167-4454-4c20-973f-952ee381cbbe/quinn-shoppable-videos-457/assets/WidgetCutoffPrice-svelte.js",
    "https://cdn.shopify.com/extensions/3bb43167-4454-4c20-973f-952ee381cbbe/quinn-shoppable-videos-457/assets/WidgetDiscount-svelte.js"
  ];

  function refreshScripts() {
    scriptUrls.forEach((url) => {
      const oldScript = document.querySelector(`script[src="${url}"]`);
      if (oldScript) oldScript.remove(); // Remove existing if found

      const newScript = document.createElement('script');
      newScript.src = url + '?v=' + new Date().getTime(); // Add cache-buster
      newScript.type = 'text/javascript';
      newScript.async = true;
      document.body.appendChild(newScript);
    });
  }

  // To fix quinn video saw onclick of swatch function end

  const templateSectionId = sectionId.replace("shopify-section-", "");
  const sectionRootEl = document.getElementById(sectionId);
  if (sectionRootEl) {
    // pointerdown / touchstart too: touch screens never fire a hover, so on mobile the
    // product used to start loading only AFTER the tap.
    ["pointerenter", "pointerdown", "touchstart"].forEach(function (evtName) {
    sectionRootEl.addEventListener(
      evtName,
      function (e) {
        const sw = e.target.closest?.(".tab-swatch");
        const pk = e.target.closest?.(".pack-swatch");
        const el = sw || pk;
        if (!el) return;
        if (pk && pk.closest(".cross-variant")) return;
        if (sw) {
          const ts = sw.closest(".type_swatch");
          if (ts && ts.classList.contains("pack-meta-swatch")) return;
        }
        const handle = el.getAttribute("data-phandle");
        if (handle) {
          preloadSwatchProductSection(handle, sectionId, templateSectionId);
        }
      },
      true
    );
    });
  }

  // Warm every design swatch's product in the background shortly after the page is
  // ready (2 at a time, idle time only), so a click finds it already cached and swaps
  // instantly instead of waiting on the network.
  (function warmDesignSwatches() {
    try {
      const conn = navigator.connection;
      if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ""))) return;
    } catch (e) {
      /* ignore */
    }
    const root = document.getElementById(sectionId);
    if (!root) return;
    const seen = new Set();
    const queue = [];
    root.querySelectorAll(".type_swatch .tab-swatch").forEach(function (btn) {
      const ts = btn.closest(".type_swatch");
      if (ts && ts.classList.contains("pack-meta-swatch")) return;
      if (btn.classList.contains("active")) return;
      const h = btn.getAttribute("data-phandle");
      if (h && !seen.has(h)) {
        seen.add(h);
        queue.push(h);
      }
    });
    if (!queue.length) return;
    const MAX = 30;
    queue.length = Math.min(queue.length, MAX);

    function worker() {
      const h = queue.shift();
      if (!h) return;
      const p = preloadSwatchProductSection(h, sectionId, templateSectionId);
      Promise.resolve(p).then(function () {
        deferSwatchSecondaryWork(worker);
      });
    }
    function start() {
      worker();
      worker();
    }
    function schedule() {
      if (typeof requestIdleCallback === "function") {
        requestIdleCallback(start, { timeout: 3000 });
      } else {
        setTimeout(start, 1500);
      }
    }
    if (document.readyState === "complete") schedule();
    else window.addEventListener("load", schedule, { once: true });
  })();

  function refreshProductRecommendations(productId) {
    const productRecommendationsSection = document.querySelector(
      ".m-product-recommendations"
    );
    if (!productRecommendationsSection) return;

    const nearestSectionR =
      productRecommendationsSection.closest(".shopify-section");
    if (!nearestSectionR?.id) return;

    const templateIdR = nearestSectionR.id.replace("shopify-section-", "");
    const root = getShopifyRoutesRoot();

    fetch(
      `${root}recommendations/products?product_id=${encodeURIComponent(productId)}&limit=8&section_id=${encodeURIComponent(templateIdR)}&intent=related`
    )
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, "text/html");
        const recommendations = html.querySelector(".m-product-recommendations");
        if (recommendations && recommendations.innerHTML.trim().length > 0) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((error) => {
        console.error("Error fetching product recommendations:", error.message);
      });
  }

  // Listen for click events on the parent container
  document
    .getElementById(sectionId)
    .addEventListener("click", async function (e) {
      // Size selection is handled by bindProductSizeSelectionOnce (delegated); do not call recordSizeSelection here.
      // Check if the clicked element or its parent is a swatch
      const swatch = e.target.closest(".tab-swatch");
      const pack = e.target.closest(".pack-swatch");
      if (!swatch && !pack) return; // Not a swatch, ignore

      // Guard: pack-meta swatches and cross-variant packs are handled by
      // lavi-cross-variant.liquid via Section API (faster). Skip them here.
      if (pack && pack.closest('.cross-variant')) return;
      if (swatch) {
        const tsDiv = swatch.closest('.type_swatch');
        if (tsDiv && tsDiv.classList.contains('pack-meta-swatch')) return;
      }

      e.preventDefault?.();

      const target = swatch || pack;
      const productHandle = target.getAttribute("data-phandle");
      const productId = target.getAttribute("data-pid");
      if (!productHandle) return;

      // Re-click on the colour that is already shown / already loading: nothing to do.
      if (
        productHandle === __acSwatchPendingHandle ||
        (!__acSwatchPendingHandle && target.classList.contains("active"))
      ) {
        return;
      }

      // Latest click wins. A click is never dropped any more: if an earlier swap is
      // still running, this one supersedes it (stale work bails out via the token).
      const seq = ++__acSwatchSeq;
      __acSwatchPendingHandle = productHandle;
      const isLatest = () => seq === __acSwatchSeq;

      // Instant visual feedback: highlight the clicked colour on the very first click.
      try {
        const group = target.closest(".type_swatch")?.parentElement;
        (group || sectionRootEl)
          .querySelectorAll(".tab-swatch.active")
          .forEach((el) => el.classList.remove("active"));
        target.classList.add("active");
      } catch (err) {
        /* cosmetic only */
      }

      try {
        const templateId = sectionId.replace("shopify-section-", "");

        toggleAddToCartButtons(false);

        // Fetch the product info AND the image carousel together, then swap both in the
        // same moment - so the images change as fast as the text beside them.
        const [new_html] = await Promise.all([
          fetchMainProductSectionInnerHtml(productHandle, sectionId, templateId),
          fetchAuxSectionsJson(productHandle, collectOrderedProductAjaxSections()),
        ]);
        if (!isLatest()) return; // a newer click took over
        const sectionEl = document.getElementById(sectionId);
        sectionEl.innerHTML = new_html;
        activateInlineScripts(sectionEl);

        // Re-point xflow at the swapped-in product immediately (the ProductVariantDataUpdated
        // event below only fires after the slow reselectSizeButton await, ~3.5s later).
        if (typeof acResyncXflowAfterProductSwap === "function") {
          acResyncXflowAfterProductSwap();
        }

        history.pushState({}, "", productUrlFromHandle(productHandle));

        // Apply the carousel / banner / Lavi Advance sections in the same tick as the
        // main swap (their JSON is already fetched above), so images and content change
        // together instead of the images trailing behind.
        const auxRefresh = refreshProductAjaxSectionsSequential(productHandle).catch(
          function (err) {
            console.warn("Section refresh after swatch swap failed", err);
          }
        );

        handleTabSwatches();
        hidePackofColorSwatchonSingleProduct();

        if (swatch) {
          styleSelect();
          addStock();
          swatchinventory();
          handleTabSwatches();
          updateSwatchGroups();
        }

        // The swap is done and the UI is usable: stop treating the page as "busy".
        // (The slow tail below used to keep a lock held, so clicks made meanwhile
        // were silently ignored - the "need to click twice" bug.)
        if (isLatest()) __acSwatchPendingHandle = "";

        if (typeof window.ensureSnfSizeCalculator === "function") {
          await window.ensureSnfSizeCalculator(sectionEl);
        }
        await reselectSizeButton(productHandle);

        if (!isLatest()) return;
        toggleAddToCartButtons(true);
        document.dispatchEvent(new CustomEvent("ProductVariantDataUpdated"));
        eagerLoadSwatchImages(sectionEl);

        await auxRefresh;

        // Phase 3: lower-priority updates (idle)
        deferSwatchSecondaryWork(function () {
          if (!isLatest()) return;
          if (window.Quinn?.functions?.resetupQuinnWidgetOnProductPage) {
            window.Quinn.functions.resetupQuinnWidgetOnProductPage({ productId });
          }
          const productFeatureSlider = document.querySelector(
            ".product-features-slider"
          );
          if (productFeatureSlider && typeof window.featuredSlider === "function") {
            window.featuredSlider(productFeatureSlider);
          }
          if (productId) {
            refreshProductRecommendations(productId);
          }
        });
      } catch (err) {
        // Hard fallback: never leave the shopper on a dead click.
        console.warn("Swatch swap failed, loading product page instead", err);
        if (isLatest()) {
          __acSwatchPendingHandle = "";
          toggleAddToCartButtons(true);
          window.location.href = productUrlFromHandle(productHandle);
        }
      } finally {
        if (isLatest()) __acSwatchPendingHandle = "";
      }
    });

  function swatchinventory() {
    // Select size options
    const sizeOptions = document.querySelectorAll(
      'variant-button[data-picker-field="radio"][data-option-name="Size"]'
    );
    // console.log("Size options found:", sizeOptions.length);
    if (sizeOptions.length === 0) {
      console.error("No size option elements found.");
      return;
    }

    // Size selection event
    sizeOptions.forEach(function (sizeOption) {
      if (sizeOption.dataset.acSwatchInventoryBound === "1") return;
      sizeOption.dataset.acSwatchInventoryBound = "1";
      sizeOption.addEventListener("click", function () {
        selectedSize = lastSelectedSize.selectedValue;
        applyDesignSwatchInventoryForSize(selectedSize);
      });
    });
  }
  swatchinventory();
  handleTabSwatches();

  // Tab state is already re-applied after section swaps via reselectTab()/styleSelect().
  // Avoid re-clicking tabs here to prevent extra layout flicker.
 
});
//swatch groups (Prints / Solids) — replaces the old ALL/PRINTS/SOLIDS/NEW tab UI

function groupSwatchesByType(container) {
  const swatches = Array.from(
    container.querySelectorAll(":scope > .type_swatch")
  );
  if (!swatches.length) return;

  const prints = [];
  const solids = [];
  swatches.forEach((sw) => {
    // Pack-meta swatches are controlled by pack-size filtering elsewhere — leave them where they are
    if (sw.classList.contains("pack-meta-swatch")) return;
    const isPrint = sw.classList.contains("prints");
    const isSolid = sw.classList.contains("solids");
    if (isPrint) prints.push(sw);
    if (isSolid) solids.push(sw);
  });

  // No Prints/Solids tags at all on this product — nothing to group.
  // Leave the swatches exactly as rendered (horizontal row) instead of
  // hiding them and forcing the container into the vertical grouped layout.
  if (!prints.length && !solids.length) {
    container.dataset.grouped = "1";
    return;
  }

  swatches.forEach((sw) => {
    if (sw.classList.contains("pack-meta-swatch")) return;
    const isPrint = sw.classList.contains("prints");
    const isSolid = sw.classList.contains("solids");
    if (!isPrint && !isSolid) {
      sw.style.display = "none";
      return;
    }
    sw.style.display = "inline-block";
  });

  function buildGroup(label, items) {
    if (!items.length) return null;
    const group = document.createElement("div");
    group.className = "swatch-group";
    group.dataset.group = label.toLowerCase();

    const title = document.createElement("div");
    title.className = "swatch-group-title";
    title.innerHTML = `${label} <span class="design-count">(${items.length})</span>`;

    const itemsWrap = document.createElement("div");
    itemsWrap.className = "swatch-group-items";
    items.forEach((el) => itemsWrap.appendChild(el));

    group.appendChild(title);
    group.appendChild(itemsWrap);
    return group;
  }

  const printsGroup = buildGroup("Prints", prints);
  const solidsGroup = buildGroup("Solids", solids);

  if (printsGroup) container.appendChild(printsGroup);
  if (solidsGroup) container.appendChild(solidsGroup);

  container.classList.add("swatch-groups");
  container.classList.remove("inline-flex");
  container.dataset.grouped = "1";
}

function updateSwatchGroups() {
  const reviewContainer = document.querySelector(".pp-swatch");
  if (!reviewContainer) {
    console.error("Error: .review container not found.");
    return;
  }
  const runGrouping = function () {
    const container = reviewContainer.querySelector(".product-design-option");
    if (!container) return;

    if (container.dataset.grouped !== "1") {
      groupSwatchesByType(container);
    }

    container.querySelectorAll(".swatch-group").forEach((group) => {
      const items = group.querySelectorAll(
        ".swatch-group-items > .type_swatch"
      );
      let count = 0;
      items.forEach((sw) => {
        if (!sw.classList.contains("empty-span")) count++;
      });
      const span = group.querySelector(".design-count");
      if (span) span.textContent = `(${count})`;
    });

    // Reveal the swatches now that grouping is applied — this row is kept
    // hidden by CSS (see .pp-swatch .product-design-option:not([data-grouped]))
    // specifically so the ungrouped/flat order is never shown to the shopper.
    container.dataset.grouped = "1";
  };
  // Grouping only reorders DOM nodes that already exist by the time this is
  // called (server-rendered on first load, or already swapped in on AJAX
  // updates), so there is no real async work to wait for. Previously this
  // used setTimeout(..., 1000), which forced a visible 1s+ flash of the
  // ungrouped swatch row before Prints/Solids appeared. requestAnimationFrame
  // still lets the DOM settle but removes the artificial delay.
  if (typeof requestAnimationFrame === "function") {
    requestAnimationFrame(runGrouping);
  } else {
    setTimeout(runGrouping, 0);
  }
}

function handleSizeSelection(selectedSize) {
  // console.log('Selected size:', selectedSize.selectedValue);
  //localStorage.setItem("selectedSize", JSON.stringify(selectedSize));
  // Update the global variable
  lastSelectedSize.selectedValue = selectedSize.selectedValue;
  if (typeof window.setAcPdpSizeMemory === "function") {
    window.setAcPdpSizeMemory(lastSelectedSize.selectedValue);
  }
  selectedSize = lastSelectedSize.selectedValue;
}

function clearStaleSizeSelection() {
  const sizeField =
    typeof window.findMainProductSizeVariantButton === 'function'
      ? window.findMainProductSizeVariantButton()
      : document.querySelector('.m-main-product variant-button[data-option-name="Size"]')
  if (!sizeField) return
  sizeField.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
    input.checked = false
  })
}

function clearAcPdpSizeMemoryAndSelection() {
  lastSelectedSize.selectedValue = ''
  if (typeof window.setAcPdpSizeMemory === 'function') {
    window.setAcPdpSizeMemory('')
  }
  clearStaleSizeSelection()
}

function reselectSizeButton(productHandle) {
  const sizeValue =
    lastSelectedSize.selectedValue ||
    (typeof window.getAcPdpSizeMemory === 'function' ? window.getAcPdpSizeMemory() : '')
  if (!sizeValue) return Promise.resolve()

  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      const applySelection = window.applyAcPdpSizeRadioSelection
      const findSizeField = window.findMainProductSizeVariantButton
      if (typeof applySelection !== 'function' || typeof findSizeField !== 'function') {
        resolve()
        return
      }

      const sizeField = findSizeField()
      if (!sizeField) {
        clearAcPdpSizeMemoryAndSelection()
        resolve()
        return
      }

      let targetInput = null
      const key = sizeValue.trim().toLowerCase()
      sizeField.querySelectorAll('input[type="radio"]').forEach((input) => {
        if ((input.value || '').trim().toLowerCase() === key) targetInput = input
      })

      if (!targetInput || !applySelection(sizeField, targetInput)) {
        const stillChecked = sizeField.querySelector('input[type="radio"]:checked')
        if (stillChecked) {
          lastSelectedSize.selectedValue = stillChecked.value
          if (typeof window.setAcPdpSizeMemory === 'function') {
            window.setAcPdpSizeMemory(stillChecked.value)
          }
          resolve()
          return
        }
        clearAcPdpSizeMemoryAndSelection()
        resolve()
        return
      }

      lastSelectedSize.selectedValue = targetInput.value
      resolve()
    })
  })
}

window.reselectSizeButton = reselectSizeButton;

// Function to fetch variant ID by handle and size
function fetchProductVariantIdByHandle(handle, size) {
  var url = "/products/" + handle + ".json";
  
  return fetch(url)
    .then(function (response) {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error("Error fetching product by handle: " + handle);
      }
    })
    .then(function (data) {
      var variants = data.product.variants;
      var matchingVariant = variants.find(function (variant) {
        
        return variant.title === size;
      });

      if (matchingVariant) {
        // console.log("Product Handle:", handle, "Size:", size, "Variant ID:", matchingVariant.id);
        return matchingVariant.id; // Return the found variant ID
      } else {
        console.error("Matching variant not found");
        return null; // Return null if no matching variant is found
      }
    });
}

// Example usage: Update the variant ID in the product form
function updateVariantIdInForm(productHandle, selectedSize) {
  fetchProductVariantIdByHandle(productHandle, selectedSize)
    .then((variantId) => {
      if (variantId) {
        // Assuming there's only one product form on the page
        // Find the input field within .m-product-form that holds the variant ID
        const variantInput = document.querySelector(
          '.m-product-form input[name="id"][data-selected-variant]'
        );
        if (variantInput) {
          // Update the value of the input field with the fetched variant ID
          variantInput.value = variantId;
          // console.log("Variant ID updated in form:", variantId);
        } else {
          console.error("Variant input field not found in form");
        }
        // Find the select dropdown within the form that holds the variant IDs
        const variantSelectDropdown = document.querySelector(
          ".m-sticky-addtocart .m-product-option--dropdown-select"
        );
        if (variantSelectDropdown) {
          // Iterate over options to match the variantId
          Array.from(variantSelectDropdown.options).forEach((option) => {
            if (option.value === variantId.toString()) {
              // Mark this option as selected
              option.selected = true;
              // console.log("Variant ID selected in dropdown:", variantId);
            }
          });
        } else {
          console.error("Variant select dropdown not found in form");
        }
      } else {
        console.error("Failed to fetch variant ID");
      }
    })
    .catch((error) =>
      console.error("Error updating variant ID in form:", error)
    );
}

updateSwatchGroups();
window.onload = function () {
  // Reset selectedValue on page reload
  if(document.querySelector(".tab-swatch.active")){
    setTimeout(function(){
      // console.log("lastSelectedSize.selectedValue", lastSelectedSize);
      let productHandle = document.querySelector(".tab-swatch.active").dataset.phandle;
      let selectedSize = JSON.parse(localStorage.getItem("selectedSize"));
      if(selectedSize){
      updateVariantIdInForm(productHandle, selectedSize.selectedValue);
      }
      lastSelectedSize.selectedValue = "";
      localStorage.removeItem("selectedSize");
      localStorage.removeItem("selectedVariant");
    },500)
  }
  // Create an IntersectionObserver
  const observer = new IntersectionObserver((entries, observerInstance) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Run your function once when visible
        if (typeof window.MOUSEHOVEREVENT === 'function') {
          console.log('sdasads');
          window.MOUSEHOVEREVENT();
        }

        // Stop observing after running once
        observerInstance.unobserve(entry.target);
      }
    });
  }, {
    root: null, // viewport
    threshold: 0.1 // run when 10% of section is visible
  });

  // Start observing the product recommendations section
  const target = document.querySelector('product-recommendations');
  if (target) {
    observer.observe(target);
  }
};

document.addEventListener("DOMContentLoaded", function () {
	handleTabSwatches();
  });

/* ==========================================================================
   xflow back-in-stock re-sync after an AJAX design-swatch swap.
   xflow injects its <xflow-bis-button> once on page load via a renderer element
   that lives inside the product section — the Section Rendering API swatch swap
   replaces that section (no reload), so the renderer is gone and xflow never
   re-injects; the main ATC stays "Sold Out" instead of "Notify me".
   Fix: on the theme's post-swap event, seed xflow with the swapped-in product's
   data and create the <xflow-bis-button> ourselves (its connectedCallback
   self-initializes: reads the product, shows/hides vs the ATC by availability,
   and opens the correct per-product modal). Only touches xflow once a swap has
   happened, so normal (non-swapped) pages are left entirely to xflow.
   ========================================================================== */
var __acXflowSwapActive = false;

function acXflowCampaignId(X) {
  var camps = X.Campaigns;
  if (Array.isArray(camps) && camps[0]) return camps[0].id || camps[0]._id || camps[0].campaignId || null;
  if (camps && typeof camps === 'object') {
    var k = Object.keys(camps)[0];
    return (camps[k] && (camps[k].id || camps[k]._id)) || k || null;
  }
  return null;
}

function acInjectXflowButton(X, form, productId) {
  var atc = form && form.querySelector('[name="add"]');
  var cfg = X.FormConfigs && X.FormConfigs.notifyButton;
  if (!atc || !cfg || !cfg.buttonPosition || !cfg.buttonPosition.inline) return;
  var campId = acXflowCampaignId(X);
  if (!campId) return;
  var wrap = document.createElement('div');
  wrap.className = 'xflow-bis-button__wrapper';
  var btn = document.createElement('xflow-bis-button');
  btn.setAttribute('hidden', 'true');
  btn.setAttribute('data-product-id', String(productId));
  btn.setAttribute('data-campaign-id', String(campId));
  wrap.appendChild(btn);
  atc.after(wrap); // connectedCallback fires synchronously and initializes the button
}

function acResyncXflowAfterProductSwap() {
  try {
    var X = window.XFLOW;
    if (!X || !X.pubSub || !X.vars || !X.vars.events || !X.Shopify) return;

    var pdEl = document.querySelector('.m-main-product #productData, #productData');
    if (!pdEl) return;
    var pd;
    try { pd = JSON.parse(pdEl.textContent); } catch (e) { return; }
    if (!pd || !pd.id) return;

    var productChanged = Number(X.Shopify.main_product_id) !== Number(pd.id);
    // Normal page that was never swapped: leave xflow's own handling alone.
    if (!productChanged && !__acXflowSwapActive) return;

    var form =
      document.querySelector('.m-product-form--main') ||
      document.querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('[name="id"]');
    var selectedVariantId =
      idInput && idInput.value
        ? Number(idInput.value)
        : (pd.selected_or_first_available_variant && pd.selected_or_first_available_variant.id) || null;

    // Seed / refresh xflow's product data (the button reads its variants from here).
    X.Shopify.products = X.Shopify.products || {};
    if (!X.Shopify.products[pd.id]) {
      X.Shopify.products[pd.id] = {
        id: pd.id,
        handle: pd.handle,
        title: pd.title,
        selected_variant_id: selectedVariantId,
        variants: (pd.variants || []).map(function (v) {
          return {
            id: v.id,
            title: v.title,
            available: v.available,
            price: v.price,
            compare_at_price: v.compare_at_price,
            inventory_quantity: v.inventory_quantity,
            inventory_policy: v.inventory_policy,
            inventory_management: v.inventory_management,
            image: v.featured_image || null,
          };
        }),
      };
    } else {
      X.Shopify.products[pd.id].selected_variant_id = selectedVariantId;
    }

    if (productChanged) {
      __acXflowSwapActive = true;
      X.Shopify.main_product_id = pd.id;
      // Drop any stale button/wrapper bound to the previous product (keep app blocks).
      document.querySelectorAll('.xflow-bis-button__wrapper, xflow-bis-button').forEach(function (el) {
        if (el.classList && el.classList.contains('xflow-app-block')) return;
        el.remove();
      });
      acInjectXflowButton(X, form, pd.id);
    }

    // Update the (injected) button for the current variant — covers size changes
    // made after a swap. Harmless if no button is listening.
    X.pubSub.publish(X.vars.events.variantChange, {
      variantId: selectedVariantId,
      productId: pd.id,
      formIdentifier: form ? form.getAttribute('id') || null : null,
    });
  } catch (e) {
    /* never break the swap on xflow errors */
  }
}

// The theme fires this after every swatch swap (and size change).
document.addEventListener('ProductVariantDataUpdated', function () {
  setTimeout(acResyncXflowAfterProductSwap, 120);
});